import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';
import { Constants } from '../../../constants/constants';
import { CrearEventoEntidadDto } from '../../../dto/eventos/evento-entidad.dto';

@Injectable({
    providedIn: 'root',
})
export class EventosEntidadService {
    private apiUrl = `${environment.apiUrl}/evento`;
    constructor(
        private http: HttpClient
    ) { }

    // Crear evento entida
    crearEventoEntidad(formData: FormData) {
        return this.http.post(`${this.apiUrl}/crear`, formData);
    }

    actualizarEventoEntidad(formData: FormData, idEvento: number) {
        return this.http.post(`${this.apiUrl}/actualizar/${idEvento}`, formData);
    }
    // Eliminar evento entidad
    eliminarEventoEntidad(ids: number[]): Observable<any> {
        return this.http.delete<any>(`${this.apiUrl}/eliminar-multiples`, {
            body: { ids }
        });
    }

    // Listar eventos entidad
    listarEventosEntidad(idEntidad: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/listar/${idEntidad}`);
    }

    // Listar eventos activos
    listarEventosActivos(idEntidad:number) {
        return this.http.get<any>(`${this.apiUrl}/listar/activas?entidad=${idEntidad}`);
    }

    buscarEventoPorId(idEvento: number): Observable<any> {
        return this.http.get<any>(`${this.apiUrl}/${idEvento}`);
    }
}
